<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte novo prevzemnico:
    </h2>

    <AcceptanceFormForm
      :clients="clients"
      :countryList="countryList"
      :type="type"
      @save="save"
      @cancel="cancel"
      ref="form"
    />

    <ConfirmDialog
      ref="confirmdialogunsaved"
      title="Opozorilo"
      text="Ali želiš izhod brez shranjevanja podatkov?"
      okBtnText="Razumem"
      :normal="false"
      v-model="showWarningModal"
    />
  </div>
</template>

<script>
import AcceptanceFormForm from '@/components/AcceptanceFormForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ConfirmDialog from '@/components/ConfirmDialog'
import { mapActions } from 'vuex'
import { objectToArray } from '../utils/object'

export default {
  components: {
    AcceptanceFormForm,
    ConfirmDialog
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    type: {
      required: true,
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      countryList: [],
      showWarningModal: false,
      shouldShowWarning: false,
    }
  },
  computed: {
    clients () {
      return objectToArray(this.$store.state.clients.items)
    }
  },
  methods: {
    ...mapActions('clients', { loadClients: 'loadItems' }),
    ...mapActions('companies', ['getCountries']),
    ...mapActions('acceptanceForms', ['saveItem']),
    save ({ data, repeat = false }) {
      this.showWarningModal = false
      const redirect = repeat ? null : 'MyCompanyAcceptanceFormsEdit'
      this.saveItem({ id: this.id, ...data })
        .then(item => {
          this.$refs.form.clearForm()
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          if (redirect) {
            this.$router.push({ name: redirect, params: { id: item.id } })
          } else {
            // this.$refs.form.clearForm()
            this.$refs.form.disabled = true
          }
        })
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyAcceptanceForms' })
    }
  },
  created () {
    Promise.all([
      this.getCountries(),
      this.loadClients()
    ])
      .then(response => {
        this.countryList = response[0]
        this.showWarningModal = false
        this.asyncDataStatus_fetched()
      })
  },
  async beforeRouteLeave (to, from, next) {
    if (to.name === 'MyCompanyAcceptanceFormsEdit' || to.name === 'MyCompanyAcceptanceForms') {
      next()
    } else {
      this.showWarningModal = true
      next(await this.$refs.confirmdialogunsaved.pop())
    }
  }
}
</script>
